<template>
    <div class="sankey-wrapper">

        <DxSankey
            ref="sankeyChart"
            :data-source="sankeyData"
            source-field="source"
            target-field="target"
            weight-field="weight"
            :alignment="['center', 'center', 'center']"
            :palette="colors"
            paletteExtensionMode = "alternate"
            :size="{height:300}"
        >
            <DxTooltip
                :enabled="true"
                :customize-link-tooltip="customizeLinkTooltip"
                :customize-node-tooltip="customizeNodeTooltip"
            />
            <DxNode
                :width="40"
                :padding="80"
            />
            <DxLink 
                color-mode="gradient"
                :opacity="0.6"
            />
            <DxMargin
                :top="0"
                :bottom="30"
                :left="0"
                :right="0"
            />
            <DxLabel
                :visible="true"
                :font="{family:'Poppins',size:14,opacity:1,weight:600,color:fontColor}"
                :horizontalOffset="10"
                :zIndex="200"
            />
        </DxSankey>

    </div>
</template>
<script>
import DxSankey, {
  DxTooltip,
  DxNode,
  DxLink,
  DxMargin,
  DxLabel,
} from 'devextreme-vue/sankey';

export default {
    name: 'sankeyChart',
    props: ['transactions','darkTheme'],
    components:{
        DxSankey,
        DxTooltip,
        DxNode,
        DxLink,
        DxMargin,
        DxLabel    
    },
    data: () => ({
        weightTitle:'USD: ',
    }),
    computed:{
        sankeyData(){
            
            if (!this.transactions.general) return [];
            
            let stableIn, stableOut, cryptoIn, cryptoOut;

            let stableObj = this.transactions.general.summary[1];
            let cryptooObj = this.transactions.general.summary[0];

            if (stableObj.token == 'stable'){
                stableIn = stableObj.inbound;
                stableOut = stableObj.outbound;
            }
            if (cryptooObj.token == 'crypto'){
                cryptoOut = cryptooObj.outbound;
                cryptoIn = cryptooObj.inbound;
            }

            return [
                { source: 'Stable In', target: 'Exchanges', weight: stableIn },
                { source: 'Exchanges', target: 'Stable Out   ', weight: stableOut },
                { source: 'Crypto Out', target: 'Exchanges', weight: cryptoOut },
                { source: 'Exchanges', target: 'Crypto In   ', weight: cryptoIn },
            ]
        },
        colors(){
            return this.darkTheme ? ['#0067C7','#0067C7','#b2b2b2','#720E2D','#720E2D'] : ['#78C4E4','#78C4E4','#b2b2b2','#F8E2AC','#F8E2AC']; 
        },
        fontColor(){
            return this.darkTheme ? '#FFFFFF' : '#141721'; 
        }
    },
    methods:{
        customizeLinkTooltip(info) {
            return {
                html: `<b>${info.source} > ${info.target}</b><br/><b>${this.weightTitle}</b> ${this.addCommas(info.weight)}`
            };
        },
        customizeNodeTooltip(info) {
            let htmlText = '';
            if (info.weightIn && info.weightOut){
                htmlText = `<b>${info.label}</b><br/>
                            <b>Inbound ${this.weightTitle}</b>${this.addCommas(info.weightIn)} <br> 
                            <b>Outbound ${this.weightTitle}</b>${this.addCommas(info.weightOut)} </b>`;
            }
            else if(info.weightIn){
                htmlText = `<b>${info.label}</b><br/><b>${this.weightTitle}</b> ${this.addCommas(info.weightIn)}`;
            }
            else{
                htmlText = `<b>${info.label}</b><br/><b>${this.weightTitle}</b> ${this.addCommas(info.weightOut)}`;
            }
            return {
                html: htmlText
            };
        },
        resizeHandler() {
            this.$refs['sankeyChart'].instance.render();
        }
    },
    created() {
        window.addEventListener("resize", this.resizeHandler);
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeHandler);
    },
}
</script>
<style lang="scss">
.sankey-wrapper{
    margin-top: 40px;
    transition: 0.3s ease;
}
</style>